import {
  Grid,
  Pagination,
  Paper,
  Table,
  TableContainer,
  TableHead,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { grey } from "@mui/material/colors";
import { Fragment } from "react";
import TransactionTableItem from "./TransactionTableItem";
import TRANSACTION_STATE from "./state/TransactionState";

const infoTableCellSx = {
  fontSize: 17,
};

const TransactionTable = (props) => {
  const { mode, transactions, paging, selectTransaction } = props;
  const columns = [
    "No",
    mode.Value == TRANSACTION_STATE.RECEIPT ? "入金元" : "支払先",
    "区分",
    "金額",
    "科目",
    "担当",
    mode.Value == TRANSACTION_STATE.RECEIPT ? "入金日付" : "支払日付",
  ];
  return (
    <Fragment>
      <TableContainer component={Paper} sx={{ height: 625 }}>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map((columnName) => {
                return (
                  <TableCell
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {columnName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.Value.map((data, index) => (
              <TransactionTableItem
                data={data}
                index={(paging.Value.page - 1) * 10 + index}
                selectTransaction={selectTransaction}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ページング */}
      <Grid container display="flex" justifyContent="space-between" mt={3}>
        <Grid item xs={2}>
          {/* <SelectBox
            data={[10, 50, 100].map((x) => {
              return {
                key: x,
                value: x,
              };
            })}
            onChange={(e) => {
              // setItemsPerPage(e.target.value);
              paging.update("itemsPerPage",e.target.value);
            }}
            value={paging.Value.itemsPerPage}
            sx={{ width: 400 }}
            label={"表示件数　"}
            nullable={false}
          /> */}
        </Grid>
        <Grid item xs={8} display="flex" justifyContent="center">
          <Pagination
            count={
              Math.floor(
                paging.Value.totalQuantity / paging.Value.itemsPerPage
              ) + 1
            }
            page={paging.Value.page}
            onChange={(e, newPage) => {
              // setPage(newPage);
              // console.log(newPage);
              paging.update("page", newPage);
            }}
            variant="outlined"
            shape="rounded"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    </Fragment>
  );
};

export default TransactionTable;
